import React from 'react';
import { Link } from 'react-router-dom';

import { pathTo } from '../../App/routes';

const PlayerStatsHeader = ({ player }) => (
  <th
    key={player.jersey}
    title={player.normalized}
    className="stats-table__row-title stats-table__row-title--double"
  >
    <Link to={pathTo('player', player.id)} className="s-advanced-stats__player">
      <div className="player__jersey">#{player.jersey}</div>
      <div className="player__name">{player.normalized}</div>
    </Link>
  </th>
);

export default PlayerStatsHeader;
